import { createSelector } from "@reduxjs/toolkit";
import { EnrichingDS, InventoryFilterData } from "types";

const state = (state: any) => state.datasets;

export const getLoading = createSelector(state, (state: any) => {
  return state.isLoading;
});

export const getContentLoading = createSelector(state, (state: any) => {
  return state.isContentLoading;
});

export const getDatasets = createSelector(state, (state: any) => {
  return state.datasets;
});

export const getSampleData = createSelector(state, (state: any) => {
  return state.sampleData;
});

export const getSelectedSampleDataset = createSelector(state, (state: any) => {
  return state.selectedSampleDataset;
});

export const getErrorText = createSelector(state, (state: any) => {
  return state.errorText;
});

export const getLimitError = createSelector(state, (state: any) => {
  return state.limitError;
});

export const getDeleteModalId = createSelector(state, (state: any) => {
  return state.deleteModalId;
});

export const getHealthStatus = createSelector(state, (state: any) => {
  return state.healthStatus;
});

export const getDatasetToDuplicate = createSelector(state, (state: any) => {
  return state.datasets?.find(
    (ds: any) => ds.id === state.datasetIdToDuplicate,
  );
});

export const getEnrichingDataset = createSelector(
  state,
  (state): null | EnrichingDS => {
    return state.enrichingDataset;
  },
);

export const getFilterData = createSelector(
  state,
  (state): InventoryFilterData => {
    return state.filterData;
  },
);
